import { z } from "zod"

export const revenueSchema = z.object({
  ordersPerDay: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(1, "Average orders per day must be at least 1"),
  avgTicket: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(0.1, "Average ticket must be greater than 0"),
  errorRate: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(0)
    .max(10),
  peakLossRate: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(0)
    .max(5),
  upsellRate: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(0)
    .max(10),
  upsellValue: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(0.1, "Upsell value must be greater than 0"),
  locations: z
    .number({ invalid_type_error: "Please enter a number" })
    .min(1, "Number of locations must be at least 1")
})

export type RevenueFormValues = z.infer<typeof revenueSchema>
